import { RecordStatus } from "@shared/ui";
import { formatDate } from "@shared/utils";

export const getData = (apiData: any) => {
  if (!apiData?.section3List) return [];

  return apiData.section3List.map((item: any, index: number) => {
    const getWorkTypeLabel = () => {
      switch (item.workType) {
        case "WORK":
          return "Работа";
        case "TEST":
          return "Испытание";
        case "INSPECTION":
          return "Проверка";
        default:
          return item.workType;
      }
    };

    return {
      key: item.itemNoVersionId,
      number: item.sequenceNumber ?? index + 1,
      type: getWorkTypeLabel(),
      workTypeRaw: item.workType,
      date: formatDate(item.workDate) || "-",
      name: item.workName,
      location: item.locationDescription,
      nameLink:
        `${item?.signer?.surname} ${item?.signer?.firstName ? item?.signer?.firstName[0] : ""} ${item?.signer?.middleName ? `.${item?.signer.middleName[0]}.` : ""}`.trim(),
      role: item.signer?.position,
      status: item.status as RecordStatus,
      info: item,
      actConnect: item.actConnect,
      companyList: item.companyList ?? [],
      updateDate: item.updateDate,
      createDate: item.createDate,
    };
  });
};
